// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SenderAvatarForUser__avatar-ef7045:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/MessageLayout/SenderAvatar/SenderAvatarForUser/SenderAvatarForUser.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF","sourcesContent":[".avatar:hover {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `SenderAvatarForUser__avatar-ef7045`
};
module.exports = ___CSS_LOADER_EXPORT___;
